__turbopack_context__.v({
  "appear": "Modal-module-scss-module__NIgm-q__appear",
  "modal": "Modal-module-scss-module__NIgm-q__modal",
  "modalContent": "Modal-module-scss-module__NIgm-q__modalContent",
  "plus": "Modal-module-scss-module__NIgm-q__plus",
});
